<!-- @format -->

<template>
	<el-select v-model="selectValue" v-loading="loading" placeholder="请选择下拉选项" @change="onChange">
		<el-option
			v-for="item in list"
			:key="item.label"
			:label="item.label"
			:value="item.value"
			:disabled="disabledList?.includes(item.value)"
		/>
	</el-select>
</template>

<script setup lang="ts">
	import { useRequest } from '@power/runtime-vue3';
	import { getBussinessList } from '@/api/bussiness';

	interface Props {
		modelValue: string | string[];
		disabledList?: string[];
		isDefaultFirst?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const list = ref<{ label: string; value: string }[]>([]);

	const emit = defineEmits(['update:modelValue', 'onChange']);

	const selectValue = computed({
		get() {
			return props.modelValue || '';
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const { loading, load: getBussinessListLoad } = useRequest(getBussinessList);

	const getList = async () => {
		const res = await getBussinessListLoad();
		list.value = (res.rows || []).map((itm) => ({
			label: itm.bussinessName,
			value: itm.code,
		}));
		if (!selectValue.value.length && props.isDefaultFirst) {
			const value = Array.isArray(selectValue.value) ? [res.rows[0].code] : res.rows[0].code;
			selectValue.value = value;
			onChange(value);
		} else {
			onChange(selectValue.value);
		}
	};

	const onChange = (e) => {
		const value = list.value.filter((i) => e.includes(i.value));
		emit('onChange', value);
	};

	getList();
</script>

<style scoped></style>
